import { createFileRoute } from "@tanstack/react-router";
import SeoLocalVsGeo from "@/pages/SeoLocalVsGeo";
import { buildBreadcrumb, ldJson } from "@/lib/site-schema";

const articleSchema = {
  "@context": "https://schema.org",
  "@type": "Article",
  headline: "SEO local vs GEO: Google Maps y respuestas de IA | SEOEVOLUTION",
  description:
    "Diferencias entre SEO local para Google Maps y GEO para respuestas generativas. Objetivos, base SEO, tareas y señales de evaluación sin garantías de citación.",
  author: {
    "@type": "Organization",
    name: "SEOEVOLUTION",
    url: "https://agenciaseoevolution.com/",
  },
  publisher: {
    "@type": "Organization",
    name: "SEOEVOLUTION",
    url: "https://agenciaseoevolution.com/",
    logo: {
      "@type": "ImageObject",
      url: "https://agenciaseoevolution.com/logo.png",
    },
  },
  image: "https://agenciaseoevolution.com/logo.png",
  mainEntityOfPage: "https://agenciaseoevolution.com/seo-local-vs-geo-posicionamiento",
  inLanguage: "es",
  datePublished: "2025-01-15",
  dateModified: "2026-11-02",
};

const breadcrumbSchema = buildBreadcrumb([{ name: "SEO local vs GEO", path: "/seo-local-vs-geo-posicionamiento" }]);

export const Route = createFileRoute("/seo-local-vs-geo-posicionamiento")({
  head: () => ({
    meta: [
      { name: "twitter:card", content: "summary_large_image" },
      { title: "SEO local vs GEO: Google Maps y respuestas de IA | SEOEVOLUTION" },
      {
        name: "description",
        content:
          "Diferencias entre SEO local para Google Maps y GEO para respuestas generativas. Objetivos, base SEO, tareas y señales de evaluación sin garantías de citación.",
      },
      {
        name: "keywords",
        content: "SEO local vs GEO, Generative Engine Optimization, Google Maps, respuestas generativas, Google Business Profile",
      },
      { property: "og:type", content: "article" },
      { property: "og:url", content: "https://agenciaseoevolution.com/seo-local-vs-geo-posicionamiento" },
      { property: "og:title", content: "SEO local vs GEO: Google Maps y respuestas de IA | SEOEVOLUTION" },
      {
        property: "og:description",
        content:
          "Diferencias entre SEO local para Google Maps y GEO para respuestas generativas. Objetivos, base SEO, tareas y señales de evaluación sin garantías de citación.",
      },
      { name: "twitter:title", content: "SEO local vs GEO: Google Maps y respuestas de IA | SEOEVOLUTION" },
      {
        name: "twitter:description",
        content:
          "Diferencias entre SEO local para Google Maps y GEO para respuestas generativas. Objetivos, base SEO, tareas y señales de evaluación sin garantías de citación.",
      },
    ],
    links: [{ rel: "canonical", href: "https://agenciaseoevolution.com/seo-local-vs-geo-posicionamiento" }],
    scripts: [ldJson(breadcrumbSchema), { type: "application/ld+json", children: JSON.stringify(articleSchema) }],
  }),
  component: SeoLocalVsGeo,
});
